import {useParams} from '@aboutyou/router';

export function useArticleIdFromUrl() {
  const {articleId} = useParams<{articleId?: string}>();
  return articleId != null ? Number(articleId) : undefined;
}
